<template>
  <div class="out-ratio">
    <div class="title">
      <span class="title__h3">{{
        $lange == "en" ? "Travelling Ratio" : "工程师出差比率"
      }}</span>
      <span class="title__tip">({{$lange == 'en' ? 'Update at' : '更新于'}}：{{ updateTime }})</span>
    </div>
    <div class="content">
      <div class="table">
        <el-table size="mini" :data="ratioData" border>
          <el-table-column
            prop="code"
            :label="$lange == 'en' ? 'Travelling Ratio' : '出差比率'"
            min-width="80px"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <span>{{ codeMap[scope.row.code] }}</span>
            </template>
          </el-table-column>
          <el-table-column
            v-for="month in months"
            :prop="month.value"
            :label="month.label"
            :key="month.value"
            :formatter="formatterValue"
            min-width="60"
            show-overflow-tooltip
          >
          </el-table-column>
        </el-table>
      </div>
      <div class="chart">
        <e-charts
          style="width: 100%"
          :options="ratioOption"
          auto-resize
        ></e-charts>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";

import theme from "../graph/theme";
import ECharts from "../components/Charts.vue";
import "echarts/lib/chart/line";
import "echarts/lib/component/legend";
import "echarts/lib/component/tooltip";
import "echarts/lib/component/grid";

// const constantsTime = [
//   "一月",
//   "二月",
//   "三月",
//   "四月",
//   "五月",
//   "六月",
//   "七月",
//   "八月",
//   "九月",
//   "十月",
//   "十一月",
//   "十二月",
// ];

export default {
  name: "EngineerOutworkRatio",
  components: { ECharts },
  props: {
    codes: Array,
  },
  data() {
    // const months = new Array(12).fill(0).map((_, idx) => ({
    //   label: constantsTime[idx],
    //   value: moment().month(idx).format("YYYY-MM"),
    // }));
    const monthCode = new Array(12)
      .fill(0)
      .map((_, idx) => moment().month(idx).format("YYYY-MM"));

    return {
      // months: Object.freeze(months),
      months: [],
      monthCode: Object.freeze(monthCode),
      ratioData: [],
      rawData: [],
      updateTime: "",
      constantsTime: [
        this.$lange == "en" ? "Jan" : "一月",
        this.$lange == "en" ? "Feb" : "二月",
        this.$lange == "en" ? "Mar" : "三月",
        this.$lange == "en" ? "Apr" : "四月",
        this.$lange == "en" ? "May" : "五月",
        this.$lange == "en" ? "Jun" : "六月",
        this.$lange == "en" ? "Jul" : "七月",
        this.$lange == "en" ? "Aug" : "八月",
        this.$lange == "en" ? "Sep" : "九月",
        this.$lange == "en" ? "Oct" : "十月",
        this.$lange == "en" ? "Nov" : "十一月",
        this.$lange == "en" ? "Dec" : "十二月",
      ],
    };
  },
  computed: {
    codeMap() {
      return this.codes.reduce((pre, cur) => {
        pre[cur.code] =this.saveName(cur);
        return pre;
      }, {});
    },
    ratioOption() {
      const series = this.ratioData.map((data) => {
        const { code, ...rest } = data;
        const seriesData = this.monthCode.map((i) => rest[i]);
        return {
          name: this.codeMap[code],
          type: "line",
          data: seriesData,
        };
      });
      return {
        ...theme,
        legend: {
          top: 6,
          left: 64,
        },
        grid: {
          left: 64,
          right: 46,
          containLabel: true,
          show: true,
        },
        tooltip: {
          formatter: "{a}<br/>{b}: {c}%",
        },

        xAxis: {
          type: "category",
          data: this.constantsTime,
        },
        yAxis: {
          type: "value",
          max: 100,
          axisLabel: {
            formatter: "{value}%",
          },
        },
        series,
      };
    },
  },
  created() {
    const months = new Array(12).fill(0).map((_, idx) => ({
      label: this.constantsTime[idx],
      value: moment().month(idx).format("YYYY-MM"),
    }));
    (this.months = Object.freeze(months)),
      this.fetchOutworkRatio({ year: "2021" });
  },
  methods: {
    saveName(data) {
      if (this.$lange == "en") {
        if (data.extraData && data.extraData.en) {
          return data.extraData.en;
        }
        return data.title;
      } else {
        return data.title;
      }
    },
    formatterValue(row, column, cellValue) {
      if (cellValue) {
        return cellValue + "%";
      }
      return cellValue;
    },
    findNewestTime(res) {
      let t = "";
      res.forEach((item) => {
        const { countList } = item;
        if (!countList) return t;
        countList.forEach((obj) => {
          if (!obj.createTime) return;
          const createTime = moment(obj.createTime);
          if (!t) {
            t = createTime;
          } else {
            t = moment.max(t, createTime);
          }
        });
      });
      return t;
    },
    filterOutworkData(raw) {
      this.ratioData = raw.map((data) => {
        return data.countList.reduce(
          (pre, cur) => {
            pre[cur["countTime"]] = cur["travelRatio"];
            return pre;
          },
          { code: data.code }
        );
      });
    },
    async fetchOutworkRatio(payload) {
      const res = await this.ccRequest.do(
        "admin/fsb/employee/report/countWorkHour",
        payload,
        "GET"
      );
      this.rawData = Object.freeze(res);
      this.filterOutworkData(this.rawData);
      const updateTime = this.findNewestTime(res);
      if (updateTime) {
        this.updateTime = updateTime.format("YYYY-MM-DD HH");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.chart {
  margin-top: 16px;
  border: 1px solid #aaa7a788;
}
.title {
  border-bottom: 1px solid #e4e4e4;
  padding: 10px 20px;
}

.title__h3 {
  font-size: 18px;
  font-weight: bold;
  display: inline-block;
  margin-right: 8px;
}
.title__tip {
  color: #ccc;
}
.content {
  padding: 8px;
}

.table {
  margin-top: 16px;
}
.el-table {
  border: 1px solid #aaa7a788;
  font-size: 14px;
}
.el-table ::v-deep th.el-table__cell.is-leaf,
.el-table ::v-deep td.el-table__cell {
  border-bottom: 1px solid #aaa7a788;
  border-right: 1px solid #aaa7a788;
}
</style>
